import FolderExport from './FolderExport';
import ToolkitExport from './ToolkitExport';
import ProjectExport from './ProjectExport';
import AgentExport from './AgentExport';

type ExportButtonSubComponents = {
  FolderExport: typeof FolderExport;
  ToolkitExport: typeof ToolkitExport;
  ProjectExport: typeof ProjectExport;
  AgentExport: typeof AgentExport;
};

const ExportButton: ExportButtonSubComponents = () => null;

ExportButton.FolderExport = FolderExport;
ExportButton.ToolkitExport = ToolkitExport;
ExportButton.ProjectExport = ProjectExport;
ExportButton.AgentExport = AgentExport;

export default ExportButton;
